import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.checkout = ReducerFuncs }

export {
  Routes,
  Reducers
}
